import { db } from '../../utils/firebase';

export const getAllPublications = async () => {
  const querySnapshot = await db.collection("publications").get();
  console.log(querySnapshot)
  const promises = [];
  const content = [];
  querySnapshot.forEach(doc => {
    // doc.data() is never undefined for query doc snapshots
    const { year } = doc.data();
    // get children for each section
    promises.push(
      db
        .collection("publications")
        .doc(year)
        .collection("children")
        .get()
    );
    content.push({ year, children: [] });
  });

  const snapshots = await Promise.all(promises);
  var i = 0;
  snapshots.forEach(querySnapshot1 => {
    const childrens = [];
    querySnapshot1.forEach(doc => {
      // get single children
      const { title, papers } = doc.data();
      childrens.push({ title, papers });
    });
    //sort title in descending order so that journals come first and conference papers come second
    childrens.sort(function(a, b){
      let x = a.title.toLowerCase();
      let y = b.title.toLowerCase();
      if (x < y) {return 1;}
      if (x > y) {return -1;}
      return 0;
    });
    content[i].children = childrens;
    ++i;
  });

  // content.sort((a, b) => b.year - a.year);
  content.sort(function(a,b){
    if(a.year == "Interaction Lab PhD Dissertations") return -1;
    else if(b.year == "Interaction Lab PhD Dissertations") return 1;
    else return b.year - a.year;
  });

  return content;
}
